/* @flow */

export {headTitle} from './head-title';
